define('v3/Common/Services/Frontend/Frontend.Service',[
	'jquery',
	'v3/Common/Services/Frontend/Modal.Service',
	'v3/Common/Services/Frontend/Dialog.Service',
	'v3/Common/Services/Frontend/Popover.Service',
	'v3/Common/Services/Frontend/Mask.Service',
	'v3/Common/Services/Frontend/Notifications.Service',
	'v3/Common/Services/Frontend/EmptyPlaceholder.Service',
	'v3/Common/Bindings/Popover.Binding'
], function ($, modal, dialog, popover, mask, pnotify, placeholder) {
	function Frontend () { }

	$.extend(Frontend.prototype, {

		modal: {
			show: modal,
			hide: modal
		},

		confirm: {
			show: dialog.confirm,
			hide: dialog.confirm
		},

		alert: {
			show: dialog.alert,
			hide: dialog.alert
		},

		popover: {
			show: popover,
			hide: popover
		},

		mask: {
			show: mask.showMask,
			hide: mask.hideMask,
			toggle: mask.toggleMask
		},

		placeholder: {
			show: placeholder.show,
			hide: placeholder.hide,
			toggle: placeholder.toggle
		},

		loader: {
			show: mask.showLoader,
			hide: mask.hideLoader,
			toggle: mask.toggleLoader,

			tiny: {
				show: mask.tinyLoader.show,
				hide: mask.tinyLoader.hide,
				toggle: mask.tinyLoader.toggle
			}
		},

		notification: {
			show: pnotify.show,
			success: pnotify.success,
			error: pnotify.error,
			info: pnotify.info,
			ajax: {
				error: pnotify.ajaxError.bind(pnotify)
			}
		},

		scrollTop: function (value) { $(window).scrollTop(value); }
	});

	return new Frontend();
});
